import { styled } from '@mui/material';
import Typography from '@mui/material/Typography';

type Props = {
  isItalic: boolean;
  isUnderlined: boolean;
};

const StyledTypography = styled(Typography, {
  shouldForwardProp: (props) =>
    props !== 'isUnderlined' && props !== 'isItalic',
})<Props>(({ isItalic, isUnderlined }) => ({
  fontStyle: isItalic ? 'italic' : 'normal',
  textDecoration: isUnderlined ? 'underline' : 'none',
}));

export default StyledTypography;
